import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

const translations = {
  id: {
    // Navigation
    nav: {
      home: 'Beranda',
      about: 'Tentang Kami',
      services: 'Layanan',
      portfolio: 'Portofolio',
      blog: 'Blog',
      contact: 'Kontak',
    },
    // Hero
    hero: {
      tagline: 'Solusi Teknologi Terjangkau untuk UKM',
      subtitle: 'Kami menyediakan layanan IT yang andal, aman, dan terjangkau untuk membantu bisnis Anda berkembang di era digital.',
      cta: 'Konsultasi Gratis',
      ctaSecondary: 'Lihat Layanan',
    },
    // About
    about: {
      title: 'Tentang Kami',
      subtitle: 'Mitra Teknologi Terpercaya untuk UKM Indonesia',
      description: 'PT Naraze Solusi Teknologi adalah perusahaan teknologi informasi yang fokus menyediakan solusi IT terjangkau, andal, dan berkelanjutan bagi usaha kecil dan menengah (UKM).',
      philosophy: 'Didirikan dengan filosofi bahwa teknologi harus menjadi penopang kehidupan, bukan beban biaya.',
      vision: 'Visi',
      visionText: 'Menjadi perusahaan teknologi yang berkelanjutan dan berorientasi pada manusia, yang mampu menjadi penyangga kehidupan bagi seluruh karyawan di dalamnya, serta menjadi mitra terpercaya bagi perusahaan kecil dan menengah.',
      mission: 'Misi',
      missionItems: [
        'Membangun lingkungan kerja yang stabil, manusiawi, dan mendukung kesejahteraan jangka panjang karyawan',
        'Menyediakan solusi teknologi informasi yang andal, aman, dan terjangkau bagi UKM',
        'Mengedepankan integritas, kejujuran, dan profesionalisme dalam setiap kerja sama',
        'Menghadirkan solusi teknologi yang tepat guna dan mudah diimplementasikan',
        'Mendorong pemanfaatan teknologi modern seperti AI, IoT, dan Machine Learning secara praktis',
      ],
      values: 'Nilai-Nilai Kami',
      valuesItems: {
        integrity: { title: 'Integritas', desc: 'Menjunjung tinggi kejujuran dan tanggung jawab dalam setiap aktivitas bisnis' },
        empathy: { title: 'Empati', desc: 'Membangun perusahaan yang peduli terhadap kesejahteraan karyawan dan pelanggan' },
        innovation: { title: 'Inovasi', desc: 'Terus berinovasi untuk menghadirkan solusi yang relevan dan efektif' },
        sustainability: { title: 'Keberlanjutan', desc: 'Mengutamakan keberlanjutan jangka panjang bagi perusahaan dan pemangku kepentingan' },
        affordability: { title: 'Keterjangkauan', desc: 'Memberikan solusi teknologi dengan harga yang wajar dan terjangkau' },
      },
      leadership: 'Pimpinan',
      ceo: 'Direktur Utama / CEO',
    },
    // Services
    services: {
      title: 'Layanan Kami',
      subtitle: 'Solusi IT Lengkap untuk Bisnis Anda',
      items: {
        maintenance: {
          title: 'IT Maintenance Support & Services',
          desc: 'Layanan support IT harian, preventive & corrective maintenance, monitoring server dan jaringan.',
          features: ['Support IT on-site dan remote', 'Preventive & corrective maintenance', 'Monitoring server, jaringan, dan aplikasi', 'Troubleshooting hardware & software', 'Managed service kontrak bulanan/tahunan'],
        },
        software: {
          title: 'Software Development',
          desc: 'Pengembangan aplikasi web dan sistem internal sesuai kebutuhan bisnis Anda.',
          features: ['Pengembangan aplikasi web', 'Custom application', 'Integrasi sistem & automasi', 'Maintenance & enhancement', 'Support aplikasi'],
        },
        hardware: {
          title: 'Penjualan Hardware & Software',
          desc: 'Pengadaan perangkat IT lengkap dengan instalasi dan dukungan purna jual.',
          features: ['Pengadaan server, PC, laptop', 'Perangkat jaringan', 'Lisensi software & sistem operasi', 'Instalasi & konfigurasi', 'Dukungan purna jual'],
        },
        iot: {
          title: 'IoT, Machine Learning & AI',
          desc: 'Implementasi solusi IoT dan AI untuk optimasi dan automasi bisnis Anda.',
          features: ['Implementasi solusi IoT', 'Pengolahan & analisis data', 'Solusi Machine Learning & AI', 'Automasi proses bisnis', 'Optimasi berbasis data'],
        },
      },
      cta: 'Hubungi Kami',
    },
    // Portfolio
    portfolio: {
      title: 'Portofolio',
      subtitle: 'Proyek yang Telah Kami Kerjakan',
      viewDetails: 'Lihat Detail',
      client: 'Klien',
      year: 'Tahun',
      technologies: 'Teknologi',
      all: 'Semua',
    },
    // Blog
    blog: {
      title: 'Blog',
      subtitle: 'Artikel dan Insight Terbaru',
      readMore: 'Baca Selengkapnya',
      by: 'Oleh',
    },
    // Contact
    contact: {
      title: 'Hubungi Kami',
      subtitle: 'Siap membantu bisnis Anda berkembang',
      form: {
        name: 'Nama Lengkap',
        email: 'Email',
        phone: 'Nomor Telepon',
        company: 'Nama Perusahaan',
        service: 'Layanan yang Dibutuhkan',
        message: 'Pesan',
        submit: 'Kirim Pesan',
        selectService: 'Pilih layanan',
        success: 'Pesan Anda telah terkirim. Kami akan segera menghubungi Anda.',
        error: 'Terjadi kesalahan. Silakan coba lagi.',
      },
      info: {
        address: 'Alamat',
        email: 'Email',
        social: 'Media Sosial',
      },
    },
    // Footer
    footer: {
      description: 'Solusi teknologi informasi yang andal, aman, dan terjangkau untuk UKM Indonesia.',
      quickLinks: 'Tautan Cepat',
      services: 'Layanan',
      contact: 'Kontak',
      copyright: '© 2025 PT Naraze Solusi Teknologi. All rights reserved.',
    },
    // Testimonials
    testimonials: {
      title: 'Testimoni',
      subtitle: 'Apa Kata Klien Kami',
      comingSoon: 'Segera Hadir',
    },
    // Common
    common: {
      learnMore: 'Pelajari Lebih Lanjut',
      getStarted: 'Mulai Sekarang',
      comingSoon: 'Segera Hadir',
    },
  },
  en: {
    // Navigation
    nav: {
      home: 'Home',
      about: 'About Us',
      services: 'Services',
      portfolio: 'Portfolio',
      blog: 'Blog',
      contact: 'Contact',
    },
    // Hero
    hero: {
      tagline: 'Affordable Technology Solutions for SMEs',
      subtitle: 'We provide reliable, secure, and affordable IT services to help your business grow in the digital era.',
      cta: 'Free Consultation',
      ctaSecondary: 'View Services',
    },
    // About
    about: {
      title: 'About Us',
      subtitle: 'Trusted Technology Partner for Indonesian SMEs',
      description: 'PT Naraze Solusi Teknologi is an information technology company focused on providing affordable, reliable, and sustainable IT solutions for small and medium enterprises (SMEs).',
      philosophy: 'Founded with the philosophy that technology should be a pillar of life, not a cost burden.',
      vision: 'Vision',
      visionText: 'To become a sustainable and human-oriented technology company, capable of being a pillar of life for all employees within, and becoming a trusted partner for small and medium enterprises.',
      mission: 'Mission',
      missionItems: [
        'Build a stable, humane work environment that supports long-term employee welfare',
        'Provide reliable, secure, and affordable IT solutions for SMEs',
        'Prioritize integrity, honesty, and professionalism in every collaboration',
        'Deliver appropriate and easy-to-implement technology solutions',
        'Encourage practical use of modern technologies such as AI, IoT, and Machine Learning',
      ],
      values: 'Our Values',
      valuesItems: {
        integrity: { title: 'Integrity', desc: 'Upholding honesty and responsibility in every business activity' },
        empathy: { title: 'Empathy', desc: 'Building a company that cares about employee and customer welfare' },
        innovation: { title: 'Innovation', desc: 'Continuously innovating to deliver relevant and effective solutions' },
        sustainability: { title: 'Sustainability', desc: 'Prioritizing long-term sustainability for the company and stakeholders' },
        affordability: { title: 'Affordability', desc: 'Providing technology solutions at fair and affordable prices' },
      },
      leadership: 'Leadership',
      ceo: 'President Director / CEO',
    },
    // Services
    services: {
      title: 'Our Services',
      subtitle: 'Complete IT Solutions for Your Business',
      items: {
        maintenance: {
          title: 'IT Maintenance Support & Services',
          desc: 'Daily IT support services, preventive & corrective maintenance, server and network monitoring.',
          features: ['On-site and remote IT support', 'Preventive & corrective maintenance', 'Server, network, and application monitoring', 'Hardware & software troubleshooting', 'Monthly/yearly contract managed service'],
        },
        software: {
          title: 'Software Development',
          desc: 'Web application and internal system development tailored to your business needs.',
          features: ['Web application development', 'Custom applications', 'System integration & automation', 'Maintenance & enhancement', 'Application support'],
        },
        hardware: {
          title: 'Hardware & Software Sales',
          desc: 'Complete IT equipment procurement with installation and after-sales support.',
          features: ['Server, PC, laptop procurement', 'Network devices', 'Software & OS licensing', 'Installation & configuration', 'After-sales support'],
        },
        iot: {
          title: 'IoT, Machine Learning & AI',
          desc: 'Implementation of IoT and AI solutions for business optimization and automation.',
          features: ['IoT solution implementation', 'Data processing & analysis', 'Machine Learning & AI solutions', 'Business process automation', 'Data-driven optimization'],
        },
      },
      cta: 'Contact Us',
    },
    // Portfolio
    portfolio: {
      title: 'Portfolio',
      subtitle: 'Projects We Have Completed',
      viewDetails: 'View Details',
      client: 'Client',
      year: 'Year',
      technologies: 'Technologies',
      all: 'All',
    },
    // Blog
    blog: {
      title: 'Blog',
      subtitle: 'Latest Articles and Insights',
      readMore: 'Read More',
      by: 'By',
    },
    // Contact
    contact: {
      title: 'Contact Us',
      subtitle: 'Ready to help your business grow',
      form: {
        name: 'Full Name',
        email: 'Email',
        phone: 'Phone Number',
        company: 'Company Name',
        service: 'Service Needed',
        message: 'Message',
        submit: 'Send Message',
        selectService: 'Select a service',
        success: 'Your message has been sent. We will contact you soon.',
        error: 'An error occurred. Please try again.',
      },
      info: {
        address: 'Address',
        email: 'Email',
        social: 'Social Media',
      },
    },
    // Footer
    footer: {
      description: 'Reliable, secure, and affordable information technology solutions for Indonesian SMEs.',
      quickLinks: 'Quick Links',
      services: 'Services',
      contact: 'Contact',
      copyright: '© 2025 PT Naraze Solusi Teknologi. All rights reserved.',
    },
    // Testimonials
    testimonials: {
      title: 'Testimonials',
      subtitle: 'What Our Clients Say',
      comingSoon: 'Coming Soon',
    },
    // Common
    common: {
      learnMore: 'Learn More',
      getStarted: 'Get Started',
      comingSoon: 'Coming Soon',
    },
  },
};

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState(() => {
    if (typeof window !== 'undefined') {
      return localStorage.getItem('naraze-lang') || 'id';
    }
    return 'id';
  });

  useEffect(() => {
    localStorage.setItem('naraze-lang', language);
  }, [language]);

  const t = (key) => {
    const keys = key.split('.');
    let value = translations[language];
    for (const k of keys) {
      value = value?.[k];
    }
    return value || key;
  };

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'id' ? 'en' : 'id');
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}
